import flattenMessages from '../../../helpers/flattenMessages';

export default {
  en: flattenMessages({}, 'privacy-policy'),
  ja: flattenMessages({}, 'privacy-policy'),
};
